import './OfferCashinDialog.less';

import { dispatch } from 'nike-re-framejs';
import { Button } from 'nike-ui/src/components/button/Button';
import React, { useState } from 'react';

import { fireGAEvent } from '@/analytics';
import { formatStakeMoney } from '@/betslip/money';
import { formatMoney } from '@/common/client';
import { CheckButton } from '@/common/components/RadioButton';
import i18n from '@i18n';
import { DialogActions, DialogBody, DialogTitle } from '@/ui/dialogs/Dialog';
import CashinBetList from './CashinBetList';
import PopupNg from '@/ui/PopupNg';

function CashinOfferHeader({ amount }) {
    return (
        <>
            <h2>{i18n('cashin.offerpopup.dialogmessage')}</h2>
            <div className="cashin-popup-message">
                <div className="cashin-question">
                    <span className="text">{i18n('cashin.offerpopup.question')}</span>
                    <span className="value">{formatMoney(amount, 'EUR')}.</span>
                </div>
            </div>
        </>
    );
}

function OfferCashinDialog({ cashinOffer, closeDialog, cashinPosition }) {
    const [acceptChanges, setAcceptChanges] = useState(true);
    const [submitted, setSubmitted] = useState(false);

    function handleSubmit() {
        if (!submitted) {
            dispatch([
                'ticketus/cashin-transaction/start',
                cashinOffer.get('ticketId'),
                cashinOffer.get('amount'),
                acceptChanges,
                cashinOffer.get('version'),
                cashinPosition
            ]);
            setSubmitted(true);
            fireGAEvent('Odkup tiketu', 'Potvrdenie odkupu tiketu');
        }
    }

    return (
        <div className="cashin-popup-info">
            <DialogTitle>
                <CashinOfferHeader amount={cashinOffer.get('amount')} />
            </DialogTitle>
            <DialogBody>
                <div className="cashin-content-info">
                    <CashinBetList hash={cashinOffer.get('hash')} />
                </div>
                <div className="cashin-content-stats">
                    <span>
                        {i18n('ticketus.tiket.detail.totalOdds')}
                        <b>{cashinOffer.get('odds')}</b>
                    </span>
                    <span>
                        {i18n('jsp.tiket.vklad')}
                        <b>{formatStakeMoney(cashinOffer.toJS())}</b>
                    </span>
                    <span>
                        {i18n('ticketus.ticket.vyhra.eventualnaVyhra')}
                        <b> {formatMoney(cashinOffer.get('win'), 'EUR')}</b>
                    </span>
                </div>
                <CheckButton active={acceptChanges} onClick={() => setAcceptChanges(b => !b)}>
                    {i18n('cashin.term.accept')}
                </CheckButton>
            </DialogBody>
            <DialogActions>
                <div className="flex items-center text-center">
                    <Button
                        onClick={() => {
                            PopupNg.dispatcher.close('ticketus/cashin-dialog');
                        }}
                        className="grey"
                        label={i18n('jsp.message.zavriet')}
                    />
                    <Button
                        primary
                        onClick={handleSubmit}
                        className="cashin-offer"
                        label={i18n('cashin.offerpopup.confirm')}
                    />
                </div>
            </DialogActions>
        </div>
    );
}

export default OfferCashinDialog;
